import { SaleChangeStatusEnum } from '@src/domains/sale-changes/types/saleChange';

export interface SaleChangeFeedback {
  intent: 'success' | 'info' | 'warning' | 'danger';
  titleKey?: string;
  messageKey: string;
  dismissible: boolean;
}

export function resolveSaleChangeFeedback(status: SaleChangeStatusEnum): SaleChangeFeedback | null {
  switch (status) {
    case SaleChangeStatusEnum.Applied:
      return { intent: 'success', messageKey: 'reschedule_applied_message', dismissible: true };
    case SaleChangeStatusEnum.Expired:
      return { intent: 'danger', messageKey: 'reschedule_expired_message', dismissible: false };
    case SaleChangeStatusEnum.Pending:
      return {
        intent: 'warning',
        titleKey: 'reschedule_pending_payment_message_title',
        messageKey: 'reschedule_pending_payment_message',
        dismissible: false,
      };
    default:
      return null;
  }
}
